import { Dayjs } from "dayjs";
import { City } from "../../../components/searchbox/searchTab/flights/RoutePickerModel";

export interface CurrentSearch {
	departureDate: Dayjs;
	destinationCity: City;
	isOneWay: boolean;
	isReloading: boolean;
	originCity: City;
	passengers: SearchPassengers;
	promoCodes: string[];
	returnDate?: Dayjs;
	useAmericanMiles: boolean;
}

export interface SearchPassengers {
	adults: number;
	children: number;
	infants: number;
	teens: number;
}

export const DEFAULT_CURRENT_SEARCH: CurrentSearch = {
	departureDate: undefined,
	destinationCity: undefined,
	isOneWay: false,
	isReloading: false,
	originCity: undefined,
	passengers: {
		adults: 1,
		children: 0,
		infants: 0,
		teens: 0,
	},
	promoCodes: [],
	returnDate: undefined,
	useAmericanMiles: false,
};
